module.exports = __webpack_public_path__ + "static/media/d20kz.682e7fd7.pdf";